<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">LaTeX 文件校對</h1>
                        <h2>用 Trinka 校對 LaTeX，省時又安心</h2>
                        <p>Trinka 幫你校對 LaTeX 文件，同時保留原始程式碼格式不受影響。幾秒內就能下載含修訂記錄的 Word 檔與 TeX 原始檔，立刻提升文件品質！</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <iframe width="100%" height="310" src="https://www.youtube.com/embed/r37zNp8_EBA" title="LaTeX Proofreading | LaTeX Grammar Checker by Trinka AI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="/assets/images/yt-thumbnail/latexThumbnail.webp" width="800" height="450" alt="latex thumbnail" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>立即觀看操作教學影片，快速上手「LaTex文件校對」功能！ </p>
                        <p>透過簡單的教學影片，讓你一步步學會如何使用 Trinka。</p>
                        <p class="mb-0">還有其他問題嗎？歡迎瀏覽我們的常見問答</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>LaTeX 文件校對主要特點</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>讓 Trinka 的 LaTeX 文法與拼字檢查工具脫穎而出的特色功能</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="../../../assets/images/DownloadTrackChangesEdit.svg" loading="lazy" decoding="async" alt="review changes">
                    <h3>檢視修訂</h3>
                    <p>除了校對後的 LaTeX 檔案外，您還會獲得一份含修訂標記的 Word 文件，方便您逐一檢查與定稿。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="../../../assets/images/RetainOriginalFormatting.png" loading="lazy" decoding="async" alt="retian original formatting">
                    <h3>保留原始格式</h3>
                    <p>您的文件內容會以修訂模式呈現所有修改，確保原始格式完整保留不變。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="../../../assets/images/languageScore_icon.svg" loading="lazy" decoding="async" alt="language score">
                    <h3>語言評分</h3>
                    <p>根據各類別的修訂次數，提供文件整體語言品質的指標分數。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/TableofRevisions_icon.svg" loading="lazy" decoding="async" alt="table of revisions">
                    <h3>修訂列表</h3>
                    <p>查看依語言類別分類的詳細修訂表，快速掌握所做的修改類型。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/style_guide_icon.svg" loading="lazy" decoding="async" alt="style guide preferences">
                    <h3>選定風格指南</h3>
                    <p>根據常見的學術寫作風格指南（如 APA、AMA、AGU、ACS、IEEE），調整文法與用字，使您的稿件更符合出版標準。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/subjectAreaAndDocumentType.svg" loading="lazy" decoding="async" alt="personalization options">
                    <h3>個人化設定</h3>
                    <p>根據您的研究主題與稿件類型，客製化 Trinka 建議提醒，提供最相關的修正與建議。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <app-power-mode-section></app-power-mode-section>
</section>

<app-import-files></app-import-files>

<section class="bg-light">
    <app-security-section></app-security-section>
</section>

<section class="sampleReport section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2>查看樣本報告</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="viewSampleReportImg">
                    <img src="/assets/images/latex-sample-report.svg" width="876" height="557" class="img-fluid" alt="latex grammar checker sample reports">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">立即提升 LaTeX 文件的語言品質</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" class="white-btn" target="_blank">開始使用</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="section-pd pb-0">
    <app-credits-info
        [title]="'使用點數完成LaTeX 文件校對'"
        [description]="'文件中每5000個單詞將花費1個點數。您可以使用免費點數並根據需要時再靈活加購。'"
        [subText]="'積分就像代幣一樣，可以讓您靈活使用多項 Trinka 功能。<br/> 高級用戶每月將獲得10個免費點數，基本用戶每月獲得4個免費點數。要瞭解更多資訊，請按一下 <a href=\'/features/credits\' class=\'text-link\'>此處</a>'"
    ></app-credits-info>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka 的 LaTeX 文件校對如何使用？
                                     </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>只要上傳您的 LaTeX 文件，系統便會自動處理並套用 AI 建議的修正內容。除了可下載已完成修正的 LaTeX 原始檔外，您還會獲得一份包含所有修改內容並使用 Microsoft Word「修訂模式」標示的 Word 文件。</p>
                                        <p>此外，系統也會提供一份詳細的校對報告，內容包括：修正次數、文法錯誤類型分類，以及整體寫作品質評分，幫助您全面掌握文稿品質。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        我可以免費試用LaTeX 文件校對功能嗎？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>只要註冊 Trinka 的基本帳戶，即可獲得 4 點免費點數，可用於免費校對 LaTeX 文件的文法與用字，輕鬆體驗專業級的寫作輔助服務！</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        使用LaTeX 文件校對需要多少點數?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>基本用戶每月可獲得4個免費點數，高級用戶每月可獲得10個免費點數。使用自動文件編輯功能， 檔中的每5000個單詞將花費1個點數。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Trinka 可以直接編輯我在 Overleaf 上的 LaTeX 文件嗎？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>不行，Trinka 目前尚未與 Overleaf 直接整合。不過您可以從 Overleaf 匯出最終的 LaTeX 檔案，然後上傳至 Trinka 進行文法校對，幾分鐘內即可完成修正。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        Trinka 的LaTeX 文件校對與 LanguageTool 有何不同？
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 專為 LaTeX 文件中的文法檢查所設計，特別適合學術與技術領域的寫作者。相較於一般工具，Trinka 能更精準地掌握專業用語、句型與學術風格的需求。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-trinka-in-other-apps></app-trinka-in-other-apps>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/joaE-2djPGE"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>